import { Link } from "react-router-dom";
import { ButtonProps } from "@chakra-ui/react";
import { PlanType } from "sdk/types";
import { LocationState, routes } from "~/constants";

interface PlanDetailsProps {
  action: string;
  handleClick: () => void;
  handleUpgradeClick: () => void;
  type: PlanType;
}

interface ButtonLinkProps extends ButtonProps {
  state: LocationState;
  to: string;
}

interface PropsByTypeAndAction {
  plus: {
    extend: ButtonLinkProps;
    payment: ButtonLinkProps;
    resubscribe: ButtonLinkProps;
    upgrade: ButtonProps;
  };
  premium: {
    extend: ButtonLinkProps;
    payment: ButtonLinkProps;
    resubscribe: ButtonLinkProps;
    upgrade: ButtonProps;
  };
}

export const buildPlanDetailsMap = (
  props: PlanDetailsProps,
): PropsByTypeAndAction => ({
  plus: {
    extend: {
      as: Link,
      onClick: props.handleClick,
      state: { extend: true, type: props.type },
      to: routes.planPayment,
    },
    payment: {
      as: Link,
      onClick: props.handleClick,
      state: { type: props.type },
      to: routes.planPayment,
    },
    resubscribe: {
      as: Link,
      onClick: props.handleClick,
      state: { resubscribe: true, type: props.type },
      to: routes.planPayment,
    },
    upgrade: {},
  },
  premium: {
    extend: {
      as: Link,
      onClick: props.handleClick,
      state: { extend: true, type: props.type },
      to: routes.planPayment,
    },
    payment: {
      as: Link,
      onClick: props.handleClick,
      state: { type: props.type },
      to: routes.planPayment,
    },
    resubscribe: {
      as: Link,
      onClick: props.handleClick,
      state: { resubscribe: true, type: props.type },
      to: routes.planPayment,
    },
    upgrade: {
      onClick: props.handleUpgradeClick,
    },
  },
});
